// Shared chat-widget design system — used by the dashboard preview AND widget.js.

export const SIZE_MAP = {
  sm: { panelW: 340, panelH: 540, launcher: 52, icon: 22 },
  md: { panelW: 390, panelH: 620, launcher: 60, icon: 26 },
  lg: { panelW: 420, panelH: 680, launcher: 68, icon: 28 },
};

export const CORNER_MAP = {
  sharp: { panel: 6, launcher: 10, bubble: 8 },
  rounded: { panel: 18, launcher: 16, bubble: 16 },
  soft: { panel: 26, launcher: 22, bubble: 22 },
};

// 5 ready-made templates inspired by popular chat widgets on the market.
export const WIDGET_TEMPLATES = [
  { id: "classic", label: "Klassisk", desc: "Vår standarddesign – ren rund bubbla.",
    preset: { launcher_shape: "circle", widget_size: "md", corner_style: "rounded", launcher_label: "", widget_offset: 20 } },
  { id: "modern", label: "Modern", desc: "Stor mjuk panel, Intercom-känsla.",
    preset: { launcher_shape: "circle", widget_size: "lg", corner_style: "soft", launcher_label: "", widget_offset: 24 } },
  { id: "compact", label: "Kompakt", desc: "Pill-knapp med text, liten panel.",
    preset: { launcher_shape: "pill", widget_size: "sm", corner_style: "rounded", launcher_label: "Chatta med oss", widget_offset: 20 } },
  { id: "playful", label: "Lekfull", desc: "Rundad studsande knapp, mjuka bubblor.",
    preset: { launcher_shape: "rounded", widget_size: "md", corner_style: "soft", launcher_label: "", widget_offset: 20 } },
  { id: "minimal", label: "Minimal", desc: "Skarpa hörn, stramt & företagsmässigt.",
    preset: { launcher_shape: "pill", widget_size: "md", corner_style: "sharp", launcher_label: "Chatta med oss", widget_offset: 16 } },
];

export function computeWidgetStyles(cfg = {}) {
  const size = SIZE_MAP[cfg.widget_size] || SIZE_MAP.md;
  const corner = CORNER_MAP[cfg.corner_style] || CORNER_MAP.rounded;
  const shape = cfg.launcher_shape || "circle";
  let launcherRadius;
  if (shape === "circle") launcherRadius = size.launcher / 2;
  else if (shape === "pill") launcherRadius = 999;
  else launcherRadius = corner.launcher;
  return {
    color: cfg.primary_color || "#0033FF",
    theme: cfg.widget_theme || "light",
    side: cfg.bubble_position === "left" ? "left" : "right",
    offset: Number.isFinite(cfg.widget_offset) ? cfg.widget_offset : 20,
    panelW: size.panelW, panelH: size.panelH, launcher: size.launcher, icon: size.icon,
    panelRadius: corner.panel, bubbleRadius: corner.bubble, launcherRadius,
    isPill: shape === "pill",
    label: (cfg.launcher_label || "").trim(),
    bounce: cfg.widget_template === "playful",
  };
}
